import Toasted from 'vue-toasted';
import { handleLaravelErrors } from '@/helpers';

export default {
  expose(Vue) {
    Vue.use(Toasted, {
      theme: 'bubble',
      position: 'bottom-right',
      duration: 10 * 1000,
    });

    Vue.toasted.register('api_error', handleLaravelErrors, {
      type: 'error',
    });

    Vue.prototype.$toasted = Vue.toasted;
  },
};
